import React from 'react';
import styles from '../WheelOfFortune.module.css';
import { useUser } from '../context/UserProvider';
import { useAppConfig } from '../context/AppConfigContext';
import { APP_DEFAULTS } from '../config';
import Confetti from 'react-confetti';
import { useWindowSize } from '@custom-react-hooks/all';
import { PrizeResultType } from '../context/DataContext';

interface ModalProps {
  isVisible: boolean;
  onClose: () => void;
  winningItem: string | null;
  winningLogoUrl?: string;
  resultType?: PrizeResultType;
}

const WinningPopup: React.FC<ModalProps> = ({
  isVisible,
  onClose,
  winningItem,
  winningLogoUrl = '',
  resultType = 'win',
}) => {
  const { width, height } = useWindowSize();
  const { user } = useUser();
  const { config } = useAppConfig();

  if (!isVisible || winningItem === null) return null;

  const template =
    resultType === 'fail'
      ? config.failMessage || APP_DEFAULTS.failMessage
      : config.winMessage || APP_DEFAULTS.winMessage;
  const message = template
    .replace('{name}', user.fullName || user.email || '')
    .replace('{prize}', winningItem);

  return (
    <div className={styles.modal}>
      {resultType === 'win' && <Confetti width={width} height={height} />}
      <div className={styles.modalContent}>
        <span className={styles.close} onClick={onClose}>&times;</span>
        {winningLogoUrl && (
          <img
            src={winningLogoUrl}
            alt={winningItem}
            className={styles.modalPrizeLogo}
          />
        )}
        <p className={styles.modalMessage}>{message}</p>
      </div>
    </div>
  );
};

export default WinningPopup;
